import {
  CLEAN_CROP_PROFILE,
  CLEAN_MODULE,
  GET_MODULE_BY_ID,
  SET_SELECTED_MODULE_ID,

} from '../actions/types';
import { handleAction } from '../../utils/handleAction';

const initialState = {
  mod: {},
  modules: null,
  isLoading: false,
  selectedModuleIdCard: null,
};
const moduleReducer = (state = initialState, action) => {
  const { type, payload } = action;
  switch (type) {
    case GET_MODULE_BY_ID:
      return handleAction(state, action, {
        failure: (prevState) => ({ ...prevState, error: payload }),
        success: (prevState) => ({
          ...prevState,
          mod: payload.data
        }),
      });
      case SET_SELECTED_MODULE_ID:
      return {
        ...state,
        selectedModuleIdCard: payload
      };
      case CLEAN_CROP_PROFILE:
      return {
      selectedModuleIdCard: null
      };
    case CLEAN_MODULE:
      return {
        ...state, mod: {}, modules: null, selectedModuleIdCard: null
      };
    default:
      return state;
  }
};
export default moduleReducer;
